
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-74818ced\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./salarieLight.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./salarieLight.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-74818ced\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./salarieLight.vue.html"),
  /* scopeId */
  "data-v-74818ced",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ficheSalarie/salarieLight/salarieLight.vue.html
// module id = pGID
// module chunks = 2